export default __webpack_public_path__ + "static/media/lazyImg.033a3f06.less";